'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxForm = require('redux-form');

var _CompanyField = require('../../components/Company/CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);


var _validate = require('../../utils/validate');
var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);


var _MortgageBanner = require('./MortgageBanner.scss');var _MortgageBanner2 = _interopRequireDefault(_MortgageBanner);
var _easy_go_logo = require('../../../static/icons/easy_go_logo.png');var _easy_go_logo2 = _interopRequireDefault(_easy_go_logo);
var _mortgage_banner_background_ru = require('../../../static/images/mortgage_banner_background_ru.png');var _mortgage_banner_background_ru2 = _interopRequireDefault(_mortgage_banner_background_ru);
var _mortgage_banner_logo_ru = require('../../../static/images/mortgage_banner_logo_ru.png');var _mortgage_banner_logo_ru2 = _interopRequireDefault(_mortgage_banner_logo_ru);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Style
var validate = function validate(values) {var errors = {};

  if (!values.name) {
    errors.name = 'emptyField';
  }

  if (!values.phone_number) {
    errors.phone_number = 'emptyField';
  }

  if (values.email && !(0, _validate.emailRegexValidation)(values.email)) {
    errors.email = 'wrongEmail';
  }

  return errors;
};var

MortgageBanner = function (_Component) {_inherits(MortgageBanner, _Component);function MortgageBanner() {var _temp, _this, _ret;_classCallCheck(this, MortgageBanner);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      sending: false,
      successfully: null }, _this.


    submitForm = function (values) {
      _this.setState({ sending: true });
      _axios2.default.post('/messaging/contact-all-mortgage-companies', Object.assign({}, values, { locale: _this.props.locale })).
      then(function () {
        _this.setState({ successfully: true, sending: false });
        _this.props.reset();
      }).
      catch(function () {return _this.setState({ successfully: false, sending: false });});
    }, _this.

    renderContent = function (isRu) {return (
        _react2.default.createElement('div', { className: _MortgageBanner2.default.content },
          _react2.default.createElement('div', { className: _MortgageBanner2.default.logo },
            _react2.default.createElement('img', { src: isRu ? _mortgage_banner_logo_ru2.default : _easy_go_logo2.default, alt: '' })),

          _react2.default.createElement('div', { className: _MortgageBanner2.default.description }, _this.props.translate('title'))));}, _temp), _possibleConstructorReturn(_this, _ret);}MortgageBanner.prototype.



  render = function render() {var
    translate = this.props.translate;
    var isRu = this.props.locale === 'ru';

    return (
      _react2.default.createElement('div', { className: _MortgageBanner2.default.bannerContainer, style: { backgroundImage: isRu ? 'url(' + _mortgage_banner_background_ru2.default + ')' : undefined } },
        this.renderContent(isRu),
        _react2.default.createElement('div', { className: _MortgageBanner2.default.title }, translate('description')),
        _react2.default.createElement('div', null,
          _react2.default.createElement('form', { onSubmit: this.props.handleSubmit(this.submitForm) },
            _react2.default.createElement('div', null,
              _react2.default.createElement('div', { className: _MortgageBanner2.default.label }, translate('name'), ' *'),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'name',
                component: _CompanyField2.default,
                type: 'text'
                // placeholder={`${translate('name').toString()}*`}
                , validate: [_reduxFormValidators.required],
                translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl })),


            _react2.default.createElement('div', null,
              _react2.default.createElement('div', { className: _MortgageBanner2.default.label }, translate('phoneNumber'), ' *'),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'phone_number',
                component: _CompanyField2.default,
                type: 'text'
                // placeholder={`${translate('phoneNumber').toString()}*`}
                , validate: [_reduxFormValidators.required],
                translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl })),


            _react2.default.createElement('div', null,
              _react2.default.createElement('div', { className: _MortgageBanner2.default.label }, translate('email')),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'email',
                component: _CompanyField2.default,
                type: 'text'
                // placeholder={`${translate('email').toString()}`}
                , translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl })),


            _react2.default.createElement('button', { disabled: this.state.sending, className: 'btn btn-primary' },

              this.state.sending ?
              _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }) :
              translate('submit'))),



          _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageBanner2.default.message, this.state.successfully ? _MortgageBanner2.default.success : _MortgageBanner2.default.error) },
            this.state.successfully !== null && translate((this.state.successfully ? 'success' : 'error') + 'Message')))));




  };return MortgageBanner;}(_react.Component);


MortgageBanner.propTypes = {
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string };



var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'MortgageBanner'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale) };};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, null),
(0, _reduxForm.reduxForm)({
  form: 'mortgageBannerForm',
  validate: validate }))(

MortgageBanner);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MortgageBanner/MortgageBanner.js
// module id = 2987
// module chunks = 0